// extracted by mini-css-extract-plugin
export default {"buttonContainer":"FailureReport_buttonContainer__sX5Bv","wrapper":"FailureReport_wrapper__Gzyk6"};